import { forwardRef, HTMLProps } from 'react'
import clsx from 'classnames'
import Image from 'next/image'
import { IImage } from '@/interfaces/common'
import style from './slider-thumbs.module.scss'

interface AnalyticsSliderThumbsProps extends HTMLProps<HTMLUListElement> {
  images: IImage[]
  selectedIndex: number
  onThumbClick: (index: number) => void
}

export const SliderThumbs = forwardRef<HTMLDivElement, AnalyticsSliderThumbsProps>((props, ref) => {
  const { className, images, onThumbClick, selectedIndex } = props

  return (
    <div ref={ref}>
      <nav className={clsx(style.container, className)}>
        {images?.map((image, index) => (
          <div className={clsx(style.img, { [style.selected]: selectedIndex === index })} key={image.id}>
            <Image
              src={image.url}
              alt={image.title}
              fill
              style={{ objectFit: 'cover' }}
              onClick={() => onThumbClick(index)}
            />
          </div>
        ))}
      </nav>
    </div>
  )
})

SliderThumbs.displayName = 'SliderThumbs'
